import { useId } from 'react';
import { Stack, Typography } from '@mui/material';
import { ToggleButtonSelect } from 'framework/ui/mui-builder';
import type { SettingsPanelProps } from '../card';
import type { SelectSettings } from './FillInput';

export const SelectSettingsPanel = ({ settings, onChange }: SettingsPanelProps<SelectSettings>) => {
  const id = useId();
  return (
    <Stack useFlexGap direction="row" spacing={1.5} sx={{ alignItems: 'center' }}>
      <Typography id={id} variant="body2">
        Show as
      </Typography>
      <ToggleButtonSelect
        aria-labelledby={id}
        value={settings.display ?? 'select'}
        onChange={display => onChange({ display })}
        options={[
          { value: 'select', label: 'Select' },
          { value: 'radioButtons', label: 'Radio buttons' },
        ]}
      />
    </Stack>
  );
};
